import {CommonOptionVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class DatasetOptionsVM extends CommonOptionVM {
  [keyof: string]: any

  constructor(data: Partial<DatasetOptionsVM> = {}) {
    super(data)
    // Handle any additional dynamic properties
    for (const key in data) {
      if (!(key in this) && Object.prototype.hasOwnProperty.call(data, key)) {
        (this as any)[key] = data[key]
      }
    }
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default DatasetOptionsVM